<div class="flex flex-col items-center p-4 gap-2 bg-gray-50 w-full">
  <h1 style="font-size: xx-large; font-weight: 600; color: var(--light-color-scheme-gray-900)">
    403 Forbidden
  </h1>
  <p class="text-base font-semibold text-[var(--light-color-scheme-gray-700)]">
    {{ content ? content : ('common.component.no_permission_access' | translate) }}
  </p>
  <div *ngIf="locationUrl && locationUrl === AppRoutes.ADMIN">
    <button
      (click)="backToHomeModule()"
      class="text-white px-3 text-md h-11 min-w-[88px] flex items-center justify-center rounded-lg bg-primary-200 font-semibold bg-primary-600"
    >
      {{ 'common.component.back_to_admin_hub' | translate }}
    </button>
  </div>
</div>
